export const isRGValid = (rg) => {
  return rg ? rg.replace(/\D|\.|-/g, '').length >= 6 : false;
};
